import { Search } from "lucide-react";

export default function FilterBar({
  onSearch,
  onStatusFilter,
  onDateFilter,
  searchTerm,
  statusFilter,
  dateFilter,
}) {
  return (
    <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <Search className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="text"
          className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          placeholder="Search observations..."
          value={searchTerm}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>

      <select
        className="block w-full md:w-auto pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
        value={statusFilter}
        onChange={(e) => onStatusFilter(e.target.value)}
      >
        <option value="">All Statuses</option>
        <option value="latest">Needs Action</option>
        <option value="under">Under Control</option>
        <option value="closed">Completed</option>
      </select>

      <select
        className="block w-full md:w-auto pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
        value={dateFilter}
        onChange={(e) => onDateFilter(e.target.value)}
      >
        <option value="">All Dates</option>
        <option value="today">Today</option>
        <option value="week">Last 7 Days</option>
        <option value="month">Last 30 Days</option>
        <option value="year">Last Year</option>
      </select>
    </div>
  );
}
